export default __webpack_public_path__ + "static/media/utracker.c2b81830.png";